import React, { useState, useEffect } from 'react';
import { ArrowRight, Sparkles } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export const SplashScreen = ({ onComplete }) => {
  const { language } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);

  const handleEnter = () => {
    setIsVisible(false);
    setTimeout(() => {
      onComplete();
    }, 500);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[100] bg-gradient-to-br from-blue-600 via-blue-700 to-indigo-900 flex items-center justify-center p-6 animate-fade-in">
      {/* Animated background particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="particle particle-1"></div>
        <div className="particle particle-2"></div>
        <div className="particle particle-3"></div>
        <div className="particle particle-4"></div>
        <div className="particle particle-5"></div>
      </div>

      <div className="relative z-10 text-center space-y-8 max-w-md">
        {/* Logo */}
        <div className="animate-slide-down">
          <div className="inline-flex items-center px-6 py-3 bg-white/10 backdrop-blur-md rounded-full border border-white/20 mb-6">
            <Sparkles className="text-cyan-300 mr-2" size={20} />
            <span className="text-white text-sm font-medium">
              {language === 'tr' ? 'Endüstriyel Çözümler' : 'Industrial Solutions'}
            </span>
          </div>
          
          <h1 className="text-6xl md:text-7xl font-bold text-white mb-8">
            NanoGen
          </h1>
        </div>

        {/* Welcome message */}
        <div className="animate-slide-up">
          <p className="text-2xl md:text-3xl font-bold text-white mb-2">
            {language === 'tr' ? 'Hoş Geldiniz' : 'Welcome'}
          </p>
          <p className="text-lg text-blue-100">
            {language === 'tr' 
              ? 'Endüstriyel makine imalatında öncü çözümler'
              : 'Leading solutions in industrial machinery manufacturing'}
          </p>
        </div>

        {/* Enter button */}
        <div className="animate-bounce-slow">
          <button
            onClick={handleEnter}
            className="group inline-flex items-center px-10 py-5 bg-white text-blue-700 font-bold text-lg rounded-2xl hover:bg-cyan-50 transition-all duration-300 shadow-2xl hover:shadow-white/30 hover:scale-105"
          >
            {language === 'tr' ? 'Siteye Giriş' : 'Enter Site'}
            <ArrowRight className="ml-3 group-hover:translate-x-2 transition-transform" size={24} />
          </button>
        </div>

        {/* Decorative elements */}
        <div className="flex justify-center space-x-2 pt-8">
          <div className="w-3 h-3 bg-white rounded-full animate-pulse"></div>
          <div className="w-3 h-3 bg-cyan-300 rounded-full animate-pulse delay-75"></div>
          <div className="w-3 h-3 bg-blue-300 rounded-full animate-pulse delay-150"></div>
        </div>
      </div>
    </div>
  );
};
